<!--navigation-->
<div class="smart-scroll scrolling" #smartScroll>
  <app-nav-user></app-nav-user>
  <app-active-reservation-notice
    *ngIf="isHome && (this.isAuth.userIsAuthenticated$ | async)?.token != null"
  ></app-active-reservation-notice>
</div>
<!--hero header-->
<router-outlet></router-outlet>

<divisas-capital-footer></divisas-capital-footer>
